module.exports = __webpack_public_path__ + "static/media/work4.a76d7fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work4.png
// module id = 85
// module chunks = 0